'use strict';

var $ = require('../internals/export');

var IS_PURE = require('../internals/is-pure');

var anObject = require('../internals/an-object');

var getMapIterator = require('../internals/get-map-iterator');

var sameValueZero = require('../internals/same-value-zero');

var iterate = require('../internals/iterate'); // `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods


$({
  target: 'Map',
  proto: true,
  real: true,
  forced: IS_PURE
}, {
  includes: function includes(searchElement) {
    return iterate(getMapIterator(anObject(this)), function (key, value) {
      if (sameValueZero(value, searchElement)) return iterate.stop();
    }, undefined, true, true).stopped;
  }
});